@if (visible) {
  <!-- wrap-anywhere lets long email addresses break, so nothing here can push the setup dialog wider than itself. -->
  <section class="who-can-see tw:mt-4 tw:wrap-anywhere" aria-labelledby="who-can-see-heading">
    <h4 id="who-can-see-heading" class="tw:mb-1">Who can see this booking</h4>
    <p class="tw:text-sm tw:text-gray-600 tw:mb-2">
      People can see this booking if they are set to Every booking at this client on Client Users, or if they are named here.
      Naming someone does not send them any email.
    </p>

    @if (message) {
      <p class="field__error" role="alert">{{ message }}</p>
    }

    <h5 class="tw:mt-3 tw:mb-1">Can see every booking at this client</h5>
    @if (access?.automatic?.length) {
      <ul class="who-can-see__automatic tw:mb-2">
        @for (person of access.automatic; track person.userId) {
          <li>{{ person.name }} ({{ person.email }})</li>
        }
      </ul>
    } @else {
      <p class="tw:text-sm tw:mb-2 who-can-see__no-automatic">Nobody at this client is set to Every booking.</p>
    }

    <h5 class="tw:mt-3 tw:mb-1">Named on this booking</h5>
    @if (liveNamed.length) {
      <!-- One stacked row per person, not a wide table: the setup dialog is 480px at most, and Remove must stay in it. -->
      <ul class="who-can-see__named tw:mb-2">
        @for (grant of liveNamed; track grant.id) {
          <li class="who-can-see__grant tw:flex tw:items-start tw:gap-2 tw:py-2 tw:border-b">
            <div class="tw:flex-1 tw:min-w-0">
              <div><span class="who-can-see__name tw:font-medium">{{ grant.userName }}</span> (<span class="who-can-see__email">{{ grant.userEmail }}</span>)</div>
              <div class="tw:text-sm tw:text-gray-600">
                Added by <span class="who-can-see__added-by">{{ grant.grantedByName }}</span>
                on <span class="who-can-see__added-on">{{ grant.grantedDate | date: 'dd MMM yyyy' }}</span>,
                @if (grant.endDate) {
                  until <span class="who-can-see__until">{{ grant.endDate | date: 'dd MMM yyyy' }}</span>
                } @else {
                  <span class="who-can-see__until">no end date</span>
                }
              </div>
            </div>
            <button type="button" class="btn btn-secondary btn-sm tw:shrink-0" (click)="remove(grant)">Remove</button>
          </li>
        }
      </ul>
    } @else {
      <p class="tw:text-sm tw:mb-2 who-can-see__no-named">Nobody is named on this booking.</p>
    }

    @if (pastNamed.length) {
      <details class="tw:mb-2">
        <summary>Past ({{ pastNamed.length }})</summary>
        <ul class="who-can-see__past">
          @for (grant of pastNamed; track grant.id) {
            <li>
              {{ grant.userName }}, added by {{ grant.grantedByName }} on {{ grant.grantedDate | date: 'dd MMM yyyy' }}.
              @if (grant.revokedDate) {
                Removed by {{ grant.revokedByName }} on {{ grant.revokedDate | date: 'dd MMM yyyy' }}.
              } @else {
                Ended on {{ grant.endDate | date: 'dd MMM yyyy' }}.
              }
            </li>
          }
        </ul>
      </details>
    }

    <h5 class="tw:mt-3 tw:mb-1">Add person</h5>
    <!-- The box and its Search button sit together on one row; the box takes the room the button leaves. -->
    <div class="field">
      <label class="field__label" for="whoCanSeeSearch">Name or email address</label>
      <div class="who-can-see__search tw:flex tw:flex-wrap tw:items-stretch tw:gap-2">
        <input id="whoCanSeeSearch" class="field__control who-can-see__search-input" type="text" [(ngModel)]="searchTerm" (keydown.enter)="search(); $event.preventDefault()" />
        <button type="button" class="btn btn-secondary who-can-see__search-button tw:shrink-0" (click)="search()">Search</button>
      </div>
    </div>
    @if (searched && !people.length) {
      <p class="tw:text-sm who-can-see__no-people">No client users match.</p>
    }
    @if (people.length) {
      <div class="field">
        <label class="field__label" for="whoCanSeePerson">Person</label>
        <select id="whoCanSeePerson" class="field__control" [(ngModel)]="selected">
          <option [ngValue]="null" disabled>Please select&hellip;</option>
          @for (person of people; track person.userId) {
            <option [ngValue]="person">{{ person.name }} ({{ person.email }}){{ person.clients ? ', ' + person.clients : '' }}</option>
          }
        </select>
      </div>
      <div class="field">
        <label class="field__label" for="whoCanSeeEnd">Until (optional)</label>
        <input id="whoCanSeeEnd" class="field__control" type="date" [min]="today" [(ngModel)]="endDate" />
      </div>
      <button type="button" class="btn btn-primary who-can-see__add" (click)="add()">Add person</button>
    }
  </section>
}
